import { createSelector } from "reselect";

const selectNotificationState = store => store.notification;

export const selectNotificationList = createSelector(
    selectNotificationState,
    state => Object.values(state.list)
);

export const selectNotificationLoading = state => state.notification.loading;
export const selectNotificationSaving  = state => state.notification.saving;
export const selectNotificationError   = state => state.notification.error;
export const selectNotificationSaveError = state => state.notification.saveError;
export const selectPagination          = state => state.notification.pagination;
export const selectFilters             = state => state.notification.filters;
export const selectUpdatingIds         = state => state.notification.updatingIds;
export const selectActiveAlert         = state => state.notification.activeAlert;
export const selectViewerOpen          = state => state.notification.viewerOpen;

export default {
    selectNotificationList,
    selectNotificationLoading,
    selectNotificationSaving,
    selectNotificationError,
    selectNotificationSaveError,
    selectPagination,
    selectFilters,
    selectUpdatingIds,
    selectActiveAlert,
    selectViewerOpen
};